var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "url(#paint0_linear_2809_15779)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2809_15779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3867 28H11.3906C10.3867 28 9.53516 27.6797 8.92969 27.0742C8.32422 26.4688 8.00391 25.6133 8.00391 24.6055C8 20.2617 8 16.3398 8.00391 12.6133C8.00391 11.6094 8.32812 10.7578 8.9375 10.1562C9.54688 9.55469 10.3984 9.23438 11.4062 9.23438H15.3906C15.8789 9.23438 16.2773 9.37891 16.5469 9.65234C16.7891 9.89453 16.9141 10.2305 16.9102 10.6211C16.9023 11.4492 16.3164 11.9805 15.4102 11.9844H12.6836H11.4219C10.875 11.9844 10.7461 12.1133 10.7461 12.668V24.5742C10.7461 25.125 10.875 25.25 11.4258 25.25H17.3789C17.3789 25.25 21.3477 25.25 23.332 25.25C23.8828 25.25 24.0117 25.125 24.0117 24.5703C24.0117 23.918 24.0117 23.2656 24.0117 22.6133C24.0117 21.9375 24.0117 21.2617 24.0117 20.5859C24.0117 19.6797 24.5508 19.0898 25.3789 19.0859H25.3867C26.2188 19.0859 26.7578 19.668 26.7578 20.5703V20.9453C26.7617 22.168 26.7617 23.4336 26.7578 24.6758C26.7539 25.6406 26.4297 26.4688 25.8203 27.0703C25.2109 27.6719 24.3828 27.9922 23.4141 27.9961C22.625 27.9961 21.8359 27.9961 21.0508 27.9961H17.3867V28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6681 20.6094C16.2032 20.6094 15.7462 20.3008 15.5313 19.8438C15.2657 19.2773 15.379 18.6641 15.836 18.1992C16.4063 17.6211 16.9923 17.0391 17.5587 16.4766L18.1603 15.8789L20.1017 13.9492C21.1446 12.9141 22.1837 11.8789 23.2228 10.8398C23.2423 10.8203 23.2618 10.8008 23.2813 10.7773C22.6485 10.7656 21.2774 10.7578 20.5157 10.7539C20.0821 10.7539 19.7149 10.6133 19.4571 10.3477C19.211 10.0977 19.0821 9.75391 19.086 9.35938C19.0938 8.55078 19.6681 8.00781 20.5118 8.00391C21.5509 8 22.5821 8 23.6173 8C24.6681 8 25.6407 8 26.5938 8.00391C27.4415 8.00391 27.9923 8.54688 27.9962 9.38281C28.004 11.4727 28.004 13.543 27.9962 15.543C27.9923 16.3477 27.4298 16.9141 26.629 16.9141C25.8282 16.9141 25.2657 16.3516 25.2579 15.5508C25.254 15.1406 25.2501 14.5039 25.2462 13.8867C25.2423 13.4336 25.2423 13 25.2384 12.7109C25.2071 12.7383 25.1798 12.7656 25.1524 12.793C24.5509 13.3984 23.9493 14 23.3478 14.6055C21.5743 16.3867 19.7423 18.2305 17.9298 20.0312C17.6485 20.3047 17.297 20.4961 16.9181 20.5859C16.8321 20.6016 16.7501 20.6094 16.6681 20.6094Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2809_15779",
    x1: 0,
    y1: 18,
    x2: 36,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7831F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB930"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2809_15779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.2350a4fe4a5a043fab0ff7b435c12314.svg";
export { ForwardRef as ReactComponent };